module.exports = __webpack_public_path__ + "img/tc72 (1).7ac4111e.png";